import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";

export function PhotoUploadButton({ angle, onUploaded }) {
  const api = useApi();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/admin/car-photos", fd);
      onUploaded(r.data.url);
      toast.success("Photo uploaded");
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={pick} data-testid={`car-form-upload-input-${angle}`} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={`car-form-upload-${angle}`}
        className="mt-2 inline-flex items-center gap-1.5 rounded-md bg-white/10 px-3 py-1.5 text-xs font-semibold text-white transition-colors duration-200 hover:bg-[#FF5A00] disabled:opacity-50">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />}{busy ? "Uploading…" : "Upload photo"}
      </button>
    </>
  );
}
